import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/carApplications/task/page',
    method: 'post',
    data,
  })
}
export async function approval(data) {
  return request({
    url: '/v2/carApplications/task/check',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/carApplications/revoke',
    method: 'post',
    data,
  })
}
export async function getDetail(params) {
  return request({
    url: '/carApplications/task/detail',
    method: 'get',
    params,
  })
}
// 去掉车辆预约所有审批页面的此查询操作
export async function checkUpdateField(data) {
  return request({
    url: '/carApplications/canAmend',
    method: 'post',
    data
  })
}
export async function updateAmend(data) {
  return request({
    url: '/carApplications/amend',
    method: 'post',
    data
  })
}